var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2511 15.3967V13.9801C12.2511 13.2286 11.9525 12.5079 11.4212 11.9766C10.8898 11.4452 10.1692 11.1467 9.41772 11.1467H3.75106C2.99961 11.1467 2.27894 11.4452 1.74759 11.9766C1.21624 12.5079 0.917725 13.2286 0.917725 13.9801V15.3967",
    stroke: "#319B0C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58431 8.3134C8.14912 8.3134 9.41764 7.04487 9.41764 5.48006C9.41764 3.91525 8.14912 2.64673 6.58431 2.64673C5.0195 2.64673 3.75098 3.91525 3.75098 5.48006C3.75098 7.04487 5.0195 8.3134 6.58431 8.3134Z",
    stroke: "#319B0C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.501 15.3967V13.9801C16.5005 13.3523 16.2916 12.7424 15.9069 12.2463C15.5223 11.7501 14.9838 11.3958 14.376 11.2388",
    stroke: "#319B0C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5427 2.73882C12.1522 2.89486 12.6924 3.24931 13.0781 3.74629C13.4639 4.24326 13.6733 4.85449 13.6733 5.48361C13.6733 6.11273 13.4639 6.72396 13.0781 7.22093C12.6924 7.7179 12.1522 8.07235 11.5427 8.2284",
    stroke: "#319B0C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0.209351 0.521729)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.06a9f033e23a444ab4992784e3f0ceec.svg";
export { ForwardRef as ReactComponent };